import React from "react";
import {
  Input
} from 'reactstrap';

import { isAuthorizedCustomFieldToUser } from "../../../../helper/custom_field/helper";

const LaboralBulkLoadEmployeeListHidden = ({ formName, filter, customFields, currentUser }) => {

  const drawEmployeesHidden = () => {
    if (filter && filter?.length > 0) {
      return(
        <>
        { _.map(filter, function(item){
            return(
              <div key={ _.uniqueId(item.id) }>
                <Input type="hidden"
                  id={ `${item.id}-controldoc_id` }
                  name={ `${formName}[items_attributes][][controldoc_id]` }
                  defaultValue={ item.controldoc_id }
                />
                <Input type="hidden"
                  id={ `${item.id}-security_layer` }
                  name={ `${formName}[items_attributes][][security_layer]` }
                  defaultValue={ item.security_layer }
                />
                <Input type="hidden"
                  id={ `${item.id}-email` }
                  name={ `${formName}[items_attributes][][email]` }
                  defaultValue={ item.value }
                />
                <Input type="hidden"
                  id={ `${item.id}-name` }
                  name={ `${formName}[items_attributes][][name]` }
                  defaultValue={ item.name }
                />
                <Input type="hidden"
                  id={ `${item.id}-identifier` }
                  name={ `${formName}[items_attributes][][identifier]` }
                  defaultValue={ item.identifier }
                />
                { drawCustomFields(item) }
              </div>
              )
          })
        }
        </>
      )
    }
  }

  const drawCustomFields = (item) =>{
    return _.map(customFields, function(customField){
      return(
        <Input type="hidden"
          key={ _.uniqueId(item.customField) }
          id={ `${item.id}-${customField.code}` }
          name={ `${formName}[items_attributes][][custom_fields][${customField.code}]` }
          defaultValue={ item[customField.code] }
          disabled={ !isAuthorizedCustomFieldToUser(customField, currentUser) }
        />
      )
    })
  }

  return(
    <div className="row">
      { drawEmployeesHidden() }
    </div>
  )
}
export default LaboralBulkLoadEmployeeListHidden;
